/** Disable CSS transitions while applying theme class / next-themes update. */
export function withoutThemeTransitions(update) {
    const root = document.documentElement;
    root.classList.add("no-transitions");
    update();
    // Force style flush so the theme applies before transitions are re-enabled.
    void root.offsetHeight;
    requestAnimationFrame(() => {
        requestAnimationFrame(() => {
            root.classList.remove("no-transitions");
        });
    });
}
